import { gql } from '@apollo/client';

const ProgramandCampaignQueryHi = gql`
  query ProgramandCampaignQueryHi {
    nodeProgramAndCampaigns(first: 10, langcode: "hi") {
      nodes {
        id
        __typename
        title
        body {
          value
        }
        bannerImage {
          url
          alt
        }
        path
        uploadImage {
          ... on MediaProgramAndCampaignsImage {
            id
            name
            mediaImage1 {
              url
              alt
            }
          }
        }
        secondTitle
        video {
          ... on MediaVideo {
            id
            name
            mediaVideoFile {
              url
              name
            }
          }
        }
        thirdTitle
        thirdSectionDescription
      }
    }
  }
`;

export default ProgramandCampaignQueryHi;
